export const SOCKET_EVENT = "SOCKET_EVENT";

export const HandleSocketEvent = (payload) => ({
  type: SOCKET_EVENT,
  payload
})